// extracted by mini-css-extract-plugin
export default {"root":"styles_root__w22ib","appContent":"styles_appContent__gZs4o"};